import { render, staticRenderFns } from "./add-concerned-of-minor-modal.vue?vue&type=template&id=1628358f&"
import script from "./add-concerned-of-minor-modal.vue?vue&type=script&lang=js&"
export * from "./add-concerned-of-minor-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports